import $ from 'jquery';
import L from 'leaflet';

$(document).ready(function() {
  const $operations = $('.m-operations');


  // Map properties
  const icon = L.icon({
    iconUrl: '/assets/images/content/map/marker.png',
    iconAnchor: [8, 23],
  });
  const osmUrl = 'https://tile.openstreetmap.org/{z}/{x}/{y}.png';
  const osmAttribution = 'OpenStreetMap - Pagatelia S.L.U.';
  const osmLayer = new L.TileLayer(osmUrl, { maxZoom: 16, attribution: osmAttribution });

  //
  $operations.each(function() {
    const $thisOperations = $(this);
    const $advice = $thisOperations.find('.e-advice');
    const $table = $thisOperations.find('.e-table');

    // Print button
    $thisOperations.find('.print').on('click', (event) => {
      event.preventDefault();
      $advice.toggleClass('opened');
      $table.toggleClass('printing');
    });

    // Operations stuff
    const $operationsRow = $thisOperations.find('.table-body .table-row');

    $operationsRow.each(function() {
      const $thisOperation = $(this);
      const $toggleLink = $thisOperation.find('.expand-details');
      const $details = $thisOperation.find('.operation-details');

      // Toggle operations details
      $toggleLink.on('click', (event) => {
        event.preventDefault();
        $details.toggleClass('opened');
      });

      // Map
      const $map = $thisOperation.find('.map');

      if ($map.length > 0) {
        const lat = parseFloat($map.attr('data-lat'));
        const long = parseFloat($map.attr('data-long'));
        const latlng = new L.LatLng(lat, long);
        const map = new L.Map($map[0], { center: latlng, zoom: 16, layers: [osmLayer], scrollWheelZoom: false });
        const marker = L.marker(latlng, { icon }).addTo(map);
      }
    });
  });
});



// WEBPACK FOOTER //
// ./app/ui/modules/operations/index.js